import { GovernedChannelType, IGovernedChannelData } from "@ms-ofb/floodgate-shared-typings";
import * as Utils from "./Utils";

export class GovernedChannel implements IGovernedChannelData {
	private type: GovernedChannelType;
	private name: string;
	private cooldownSeconds: number;
	private cooldownStartTime: Date;
	private cooldownEndTime: Date;

	public constructor(type: GovernedChannelType, name: string, cooldownSeconds: number, cooldownStartTime: Date) {
		if (!Utils.isEnumValue(type, GovernedChannelType)) {
			throw new Error("type is not a valid GovernedChannelType");
		}

		if (!name) {
			throw new Error("name must not be null or empty");
		}

		if (cooldownSeconds < 0) {
			throw new Error("cooldownSeconds must not be negative");
		}

		this.type = type;
		this.name = name;
		this.cooldownSeconds = cooldownSeconds;
		this.setCooldownStartTime(cooldownStartTime);
	}

	public setCooldownStartTime(cooldownStartTime: Date): void {
		// Set the start time
		this.cooldownStartTime = cooldownStartTime;

		if (Utils.isNOU(this.cooldownStartTime)) {
			// Null cooldownStartTime means cool down has never been initiated, so set the cooldownEndTime to distant past
			this.cooldownEndTime = Utils.getDistantPast();
			return;
		}

		// Calculate the end time, but don't overflow past max.
		this.cooldownEndTime = Utils.addSecondsWithoutOverflow(this.cooldownStartTime, this.cooldownSeconds);
	}

	// @Override
	public isOpen(): boolean {
		return this.isOpenAtDate(new Date());
	}

	// @Override
	public isOpenAtDate(date: Date): boolean {
		if (!date) {
			return false;
		}

		return (date > this.cooldownEndTime);
	}

	// @Override
	public getType(): GovernedChannelType {
		return this.type;
	}

	// @Override
	public getName(): string {
		return this.name;
	}

	// @Override
	public getCooldownSeconds(): number {
		return this.cooldownSeconds;
	}

	// @Override
	public getCooldownStartTime(): Date {
		return this.cooldownStartTime;
	}

	// @Override
	public getCooldownEndTime(): Date {
		return this.cooldownEndTime;
	}
}
